import { RootState } from "@/store/store";

export const currentDashboardIdSelector = (state: RootState): string | null => {
  return state.dashboards.id;
};
